module.exports = __webpack_public_path__ + "static/media/zw.7d1a2373.svg";